@if (visible) {
  <div class="new-experience-overlay shadow-lg" data-test="tx-new-experience-banner">
    <div class="d-flex align-items-start gap-3">
      <mat-icon class="overlay-icon flex-shrink-0 overflow-visible">info</mat-icon>
      <div class="flex-fill">
        <h6 class="overlay-title m-0">Introducing the new transaction experience</h6>
        <p class="overlay-body my-2">
          Available as a preview, so you may notice some issues.
          Switch back at any time from your profile.
        </p>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button
            mat-button
            class="overlay-dismiss-button"
            [disabled]="saving"
            (click)="choose(false)"
            data-test="tx-new-experience-not-now-button"
          >
            Not now
          </button>
          <button
            mat-flat-button
            class="overlay-try-button"
            [disabled]="saving"
            (click)="choose(true)"
            data-test="tx-new-experience-try-button"
          >
            Try it
          </button>
        </div>
      </div>
    </div>
  </div>
}
